import { ClickAwayListener } from '@material-ui/core';
import { colours } from 'bz-core-controls/styles/colours';
import createReactClass from 'create-react-class';
import _ from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import InputMixin from '../../../../../mixins/input-mixin';
import PublishMixin from '../../../../../mixins/publish-mixin';
import AutosizeTextarea from './components/autosize-textarea';
import Label from './components/label';
import Picker from './components/picker';

const Edit = createReactClass({
  displayName: 'Edit',
  mixins: [PublishMixin, InputMixin('input')],

  getInitialState() {
    this.input = React.createRef();
    this.picker = React.createRef();

    return {
      open: false
    };
  },

  getDefaultProps() {
    return {
      errored: false,
      inline: false,
      maitland: false,
      mode: 'append',
      rows: 1,
      tabIndex: 1,
      warning: false,
      skipScrollTo: false,

      onBlur: () => {},
      onKeyDown: () => null
    };
  },

  onMouseDown(e) {
    e.stopPropagation();
    this.show(e);
    this.props.onMouseDown?.();
  },

  componentClickAway(e) {
    const { maitland } = this.props;
    if (maitland) {
      return;
    }

    this.hide(false);
  },

  focus() {
    const { current: input } = this.input;
    if (!!input) {
      input.focus();
    }
  },

  quickPick() {
    const { src } = this.props;
    const isArray = _.isArray(src);

    return (isArray && src.length > 0) || (!isArray && _.isObject(src));
  },

  buttons() {
    const { src } = this.props;

    return _.isString(src) && src.length > 0;
  },

  scrollIntoView(override) {
    if (this.props.skipScrollTo) {
      return;
    }
    // TODO: use this instead of scrollToInput when safari updates to support scroll to center options
    const { current: target } = !!this.state.open ? this.picker : this.input;
    if (!!target) {
      target.scrollIntoView(override);
    }
  },

  scrollToInput(override) {
    if (this.props.skipScrollTo) {
      return;
    }
    // TODO: use scrollTo instead of this when safari updates to support scroll to center options
    const { current: input } = this.input;
    if (!!input) {
      input.scrollIntoView(override);
    }
  },

  show() {
    if (this.state.open) {
      return;
    }
    this.setState({ opening: true });
    const { maitland } = this.props;
    if (maitland || this.buttons() || this.quickPick()) {
      this.setState({ open: true }, () => {
        this.scrollToInput();
      });
    }
    return setTimeout(() => this.setState({ opening: false }), 250);
  },

  hide(focusTextField, e) {
    if (this.props.maitland && focusTextField) {
      const { current: input } = this.input;
      if (!!input) {
        input.focus();
      }
      this.scrollToInput();
    }

    if (this.state.open && !this.state.opening) {
      this.setState({ open: false });
    }
  },

  onBlur(e) {
    const { maitland } = this.props;
    if (this.state.open && maitland) {
      // this stops the qp from closing due to accessing other windows such as dev tools
      const el = ReactDOM.findDOMNode(this);
      const { relatedTarget } = e;
      if (relatedTarget === null) {
        return;
      } else if (!el.contains(relatedTarget)) {
        this.hide(false);
      }
      return this.props.onBlur(e);
    }
    if (!this.state.opening) {
      return this.props.onBlur(e);
    }
  },

  onKeyDown(e) {
    if (e.keyCode == 9) {
      this.hide(false);
    } else {
      this.props.onKeyDown(e);
    }
  },

  onRequestClose(forceClose) {
    if (forceClose || (!this.props.maitland && !this.props.appendMulti)) {
      this.setState({ open: false });
    }
  },

  onTextChange(e) {
    this.props.onChange(e.target.value, e);
  },

  shouldComponentUpdate(props, state) {
    if (this.props.errored || this.props.warning) return true;
    if (this.props.value !== props.value) return true;
    if (this.props.errorText !== props.errorText) return true;
    if (this.props.src !== props.src) return true;
    if (this.state.open !== state.open) return true;

    return false;
  },

  render() {
    let className = 'text-control ';
    if (this.props.className) {
      className += this.props.className;
    }
    let inputClassName = 'inner-control';
    if (this.props.maitland) {
      inputClassName += ' maitland';
    }

    const value = this.props.value || '';

    let fieldStyle = Object.assign({}, this.props.style, {
      color: colours.grey,
      paddingTop: 1
    });
    return (
      <div className={className} onClick={this.onClick}>
        <Label
          hideLabel={this.props.hideLabel}
          label={this.props.label}
          isMarkdown={this.props.isMarkdown}
        />
        <ClickAwayListener onClickAway={this.componentClickAway} mouseEvent="onClick">
          <>
            <AutosizeTextarea
              ref={this.input}
              className={inputClassName}
              disabled={this.props.disabled}
              errored={this.props.errored}
              warning={this.props.warning && value === ''}
              errorText={this.props.errorText}
              fullWidth={true}
              maxLength={this.props.maxLength}
              multiLine={!this.props.inline}
              placeholder={this.props.placeholder}
              rows={parseInt(this.props.rows) || 0}
              spellCheck={this.props.spellCheck}
              tabIndex={this.props.tabIndex}
              style={fieldStyle}
              value={value}
              onBlur={this.onBlur}
              onChange={this.onTextChange}
              onFocus={this.show}
              onKeyDown={this.onKeyDown}
              onKeyPress={(e) => e.stopPropagation()}
              onMouseDown={this.onMouseDown}
            />
            <Picker
              {...this.props}
              ref={this.picker}
              focus={this.focus}
              hide={this.hide}
              open={this.state.open}
              onRequestClose={this.onRequestClose}
            />
          </>
        </ClickAwayListener>
        {/* MERGE - moved outside clickaway due to forward ref issue */}
      </div>
    );
  }
});

export default Edit;
